// react-accessible-accordion uses each AccordionItem's `uuid` to build DOM ids
// (e.g. `accordion__heading-<uuid>`), which must be valid HTML5 ids — ASCII
// whitespace is forbidden. Help-topic titles ("Getting Started", "Why am I
// here?") contain spaces, so passing them raw spammed the console with
// `uuid must be a valid HTML5 id` errors on every Help Centre open. Slugify the
// title to a stable, whitespace-free id. The same slug must be used wherever the
// uuid is referenced (preExpanded / onChange) so expand/collapse still matches.
export const toAccordionId = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'accordion-item';
